import { connect } from 'react-redux';

import { IAuthenticationService } from 'services/authenticationService';
import { ICustomerResponsible } from 'pages/Login';
import './ContactCard.css';

interface IContactCardProps {
  contact: ICustomerResponsible;
  authenticationService?: IAuthenticationService;
  className?: String;
}

const ContactCard = function ({ contact, className }: IContactCardProps) {
  return (
    <div className={'contact-card-container ' + className}>
      <div className={'contact-card'}>
        <div className="data-container">
          <span>{contact.displayName}</span>
          {contact.email && (
            <span>
              <a href={'mailto:' + contact.email}>
                <i className="fa fa-envelope"></i>
                {contact.email}
              </a>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default connect()(ContactCard);
